import {
  RadarChart as RRadar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

export default function CategoryRadar({ categories = [] }) {
  const data = categories.map((c) => ({
    subject: c.name.replace("Google Business Profile", "Google Profile"),
    score: c.score,
  }));
  return (
    <div className="pp-surface p-5" data-testid="category-radar">
      <div className="pp-label mb-1">Category Radar</div>
      <div className="font-display text-lg text-white mb-4">
        All eight trust dimensions.
      </div>
      <div style={{ width: "100%", height: 300, minHeight: 260 }}>
        <ResponsiveContainer width="100%" height="100%" minWidth={0}>
          <RRadar data={data} outerRadius="80%">
            <PolarGrid stroke="#333C47" />
            <PolarAngleAxis
              dataKey="subject"
              tick={{ fill: "#C7CBD1", fontSize: 10 }}
            />
            <PolarRadiusAxis
              angle={90}
              domain={[0, 100]}
              tick={{ fill: "#666", fontSize: 9 }}
              stroke="#333C47"
            />
            <Radar
              dataKey="score"
              stroke="#6CC24A"
              fill="#6CC24A"
              fillOpacity={0.18}
              strokeWidth={1.5}
            />
            <Tooltip
              contentStyle={{
                background: "#232931",
                border: "1px solid #333C47",
                borderRadius: 4,
                color: "#FFFFFF",
              }}
              labelStyle={{ color: "#C7CBD1" }}
            />
          </RRadar>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
